import { Tooltip, UnstyledButton  } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from '../Home/Home.module.css'

const NavbarLink = ({ icon: Icon, label, onClick }) => {
  return (
    <Tooltip label={label} position="right" transitionProps={{ duration: 0 }}>
      <UnstyledButton onClick={onClick} className={classes.link}>
        <FontAwesomeIcon icon={Icon} size="lg" />
      </UnstyledButton>
    </Tooltip>
  );
}


export default NavbarLink;